var appRoutes = {
  // Using default controller/directives

  // Content
  'content/articles-detail': {
    controller: 'articleDetail',
  },
  'content/articles-new': {
    controller: 'articleDetail',
  },
  'content/articles': {
    controller: 'articles',
  },
  'content/comments': {
    controller: 'comments',
  },
  'content/comments_approval': {
    controller: 'commentApproval',
  },
  'content/blocked': {
    controller: 'blocked',
  },

  // Billing
  'billing/dashboard': {
    controller: 'billing',
  },
  'billing/cards': {
    controller: 'card',
  },
  'billing/invoices-detail': {
    controller: 'invoice',
  },
  'billing/invoices': {
    controller: 'invoices',
  },
  'billing/options': {
    controller: 'options',
  },
  'billing/plans-detail': {
    controller: 'changePlan',
  },
  'billing/plans': {
    controller: 'plans',
  },

  // Panel
  'panel/profile': {
    controller: 'profile',
  },
  'panel/mystats': {},
  'panel/mytasks': {},
  'panel/bookmarks': {
    controller: 'bookmark',
  },
  'panel/bookmarks-detail': {
    controller: 'bookmarkDetail',
  },
  'panel/newsletter': {},
  'panel/notifications': {
    controller: 'notification',
  },
  'panel/tags': {
    controller: 'tag',
  },
  'panel/inbox': {
    controller: 'inbox',
  },
  'panel/approval': {
    controller: 'approval',
  },
  'panel/blocked': {},

  // Project
  'project/analytics': {},
  'project/colors': {
    controller: 'colors',
  },
  'project/dashboard': {
    controller: 'dashboard',
  },
  'project/digest-settings': {},
  'project/digest': {
    controller: 'digest',
  },
  'project/footer': {
    controller: 'footerMessage',
  },
  'project/home-message': {
    controller: 'homeMessage',
  },
  'project/home': {
    controller: 'home',
  },
  'project/integrations': {
    controller: 'integrations',
  },
  'project/menu-footer': {
    controller: 'footerMenu',
  },
  'project/header': {
    controller: 'header',
  },
  'project/menu-header': {
    controller: 'headerMenu',
  },
  'project/logo': {},
  'project/tags': {},
  'project/project': {
    controller: 'project',
  },
  'project/rules': {},
  'project/settings': {
    controller: 'settings',
  },
  'project/monetization': {
    controller: 'projectMonetization',
  },
  'project/settings-nps': {
    controller: 'projectSettingsNPS',
  },

  // Group
  'group/groups-detail': {
    controller: 'groupDetail',
  },
  'group/groups': {
    controller: 'group',
  },
  'group/new-group': {
    controller: 'groupNew',
  },

  // User
  'user/user-export': {
    controller: 'userExport',
  },
  'user/users-detail': {
    controller: 'userDetail',
  },
  'user/approval': {
    controller: 'approval',
  },
  'user/users': {
    controller: 'user',
  },
  'user/blocked': {
    controller: 'blocked',
  },

  // Course
  'course/new': {
    controller: 'new',
  },
  'course/courses-detail': {
    controller: 'detail',
  },
  'course/courses': {
    controller: 'list',
  },
};
